const getBaseUrl = (): string => {
  const base = import.meta.env?.BASE_URL ?? '/';
  return base.endsWith('/') ? base : `${base}/`;
};

export const resolveAssetUrl = (relativePath: string): string => {
  const cleanRelative = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  return `${getBaseUrl()}${cleanRelative}`;
};

export const ASSET_MANIFEST = {
  character_poc_neutral: resolveAssetUrl('assets/poc/generated/character-atlas.png'),
  effects_and_ui_shared_atlas: resolveAssetUrl('assets/poc/generated/effects-ui-atlas.png'),
  poc_atlas_2048: resolveAssetUrl('assets/poc/generated/poc-atlas-2048.png'),
  poc_atlas_4096: resolveAssetUrl('assets/poc/generated/poc-atlas-4096.png'),
} as const;
export type AssetId = keyof typeof ASSET_MANIFEST;
export const resolveAssetPath = (id: string): string => {
  if (!(id in ASSET_MANIFEST)) throw new Error(`Unknown asset id: ${id}`);
  return ASSET_MANIFEST[id as AssetId];
};

